import {StyledTextError} from './index.styled'
 
function TextError(props) {
  return <StyledTextError>{props.children}</StyledTextError>;
}

export default TextError;
